import { projectRequest } from 'store/utils/request';

export const getTestSetEntriesRequest = async (testSetId, params) => {
  try {
    return await projectRequest.get(`/test_sets/${testSetId}/entries/`, {
      params,
    });
  } catch (error) {
    throw error;
  }
};

export const addTestSetEntryRequest = async (testSetId, data) => {
  try {
    return await projectRequest.post(`/test_sets/${testSetId}/entries/`, data);
  } catch (error) {
    throw error;
  }
};

export const updateTestSetEntryRequest = async (testSetId, id, data) => {
  try {
    return await projectRequest.put(
      `/test_sets/${testSetId}/entries/${id}/`,
      data,
    );
  } catch (error) {
    throw error;
  }
};

export const deleteTestSetEntryRequest = async (testSetId, id) => {
  try {
    return await projectRequest.delete(
      `/test_sets/${testSetId}/entries/${id}/`,
    );
  } catch (error) {
    throw error;
  }
};
